import React from "react";
import { Button, Paper, TextField, Grid } from "@mui/material";
import { useMutation, useQuery } from "@apollo/client";
import { Formik, Field } from "formik";
import * as Yup from "yup";
import {
  EDITAR_PLAZA,
  OBTENER_INFO_PLAZA,
  OBTENER_PLAZAS,
} from "../../../../graphql/plazas";
const FrmEditarPlaza = ({
  setOpenDialog,
  setOpenSnackBar,
  setErrorGraph,
  id,
}) => {
  const { data, loading, error } = useQuery(OBTENER_INFO_PLAZA, {
    variables: {
      id,
    },
  });

  const [editarPlaza] = useMutation(EDITAR_PLAZA, {
    update(cache, { data: { editarPlaza } }) {
      const { obtenerPlazas } = cache.readQuery({
        query: OBTENER_PLAZAS,
      });
      cache.writeQuery({
        query: OBTENER_PLAZAS,
        data: {
          obtenerPlazas: [...obtenerPlazas, editarPlaza],
        },
      });
    },
  });
  const handleOpenDialog = () => {
    setOpenDialog(false);
  };
  if (loading) return <h1>Obteniendo información...</h1>;
  const onSubmit = async (values, formikValues) => {
    try {
      const dataInput = await editarPlaza({
        variables: {
          input: {
            id: values.id,
            nombre: values.nombre,
          },
        },
      });

      setOpenSnackBar(true);
      setErrorGraph({
        mensaje: dataInput.data.editarPlaza,
        severity: "success",
      });
      setOpenDialog(false);
    } catch (error) {
      setOpenSnackBar(true);
      setErrorGraph({ mensaje: error.message, severity: "error" });
    }
  };
  const { obtenerPlaza } = data;
  return (
    <>
      <Formik
        initialValues={{
          id: obtenerPlaza.id,
          nombre: obtenerPlaza.nombre,
        }}
        onSubmit={onSubmit}
      >
        {({ handleSubmit }) => (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit();
            }}
          >
            <Grid container alignItems="flex-start" spacing={3}>
              <Grid item xs={12}>
                <Field name="id" hidden />
                <Field name="nombre">
                  {({
                    field, // { name, value, onChange, onBlur }
                    form: { touched, errors },
                    meta,
                  }) => (
                    <TextField
                      {...field}
                      label="Nombre (s)"
                      variant="standard"
                      fullWidth
                    />
                  )}
                </Field>
              </Grid>
            </Grid>
            <Button type="submit">Editar</Button>
            <Button onClick={() => handleOpenDialog()}>Cerrar</Button>
          </form>
        )}
      </Formik>
    </>
  );
};

export default FrmEditarPlaza;
